import React, { useState, useEffect, useMemo, useRef } from 'react'
import Select from 'react-select'
import { Card } from '../../../../_components'
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import ptBR from 'date-fns/locale/pt-BR';

registerLocale('pt-BR', ptBR);

export const finishOptions = [
  { label: "Finalizar por data", value: "stop_momentum" }
]

export function Finish({data, setData, domain, errors, setErrors}) {
  const dataFinish = useMemo( () => {
    const filter = ( data.momentums ?? [] ).find( ( { type } ) => type === 'finish' )
    return filter?.values?.[0]
  }, [ data ] )

  const firstDataFinish = useRef( dataFinish )

  useEffect( () => {
    const data = firstDataFinish.current

    if ( !data ) return void 0

    const finishOption = finishOptions.find( option => option.value === data.filter )

    setData( state => ( {
      ...state,
      finish: data,
      raw_finish_filter: finishOption,
      raw_finish_value: data.value,
    } ) )
  }, [ setData ] )

  const [ , shouldShow ] = useState(true)

  const handleChange = async (e, type) => {
    if ( !e && type ) {
      let arr = data
      delete arr.finish
      delete arr.raw_finish_filter
      
      shouldShow(false)
      return setData(arr)
    }

    const raw = `raw_${type}`
    let arr = data.finish ? data.finish : []

    type = type.split('_')[1]
    shouldShow(true)
    setData({...data, finish: {...arr, [type]: e.value}, [raw]: e})
  }

  const handleDateChange = (date, type) => {
    if ( !date || !type ) return

    const raw = `raw_${type}`
    let arr = data.finish ? data.finish : []

    type = type.split('_')[1]
    const value = moment(date).format("YYYY-MM-DDTHH:mm:ss") + '.000Z'
    setData({...data, finish: {...arr, [type]: value}, [raw]: date})
  }


  return (
    <Card
      title="Finalização"
      icon="HourglassIcon"
      description={"Define o melhor momento e maneira de finalizar a execução do Momentum automaticamente."}
      required={false}
      help={"O filtro é utilizado para segmentar sua base baseado em dados já existentes. Caso escolha a opção Mobile > Sim, todos que estão registrados em sua base usando dispositivos móveis serão impactados."}
    >
      <div className={`input__group ${data.raw_finish_filter && 'input__group--nowrap'}`}>
        <Select
          className={`selectable ${data.raw_finish_filter && 'w-full'}`}
          options={finishOptions}
          value={data.raw_finish_filter}
          onChange={e => handleChange(e, 'finish_filter')}
          placeholder="Selecione o tipo de finalização"
          noOptionsMessage={() => "Nenhuma opção disponível"}
          isClearable
        />

        {
          shouldShow &&
          data.raw_finish_filter &&
            <div className="w-full">
              <div
                className={`
                  inputable__wrapper
                  ${errors.finishValue && "inputable__wrapper--error"}
                `}
              >
                <DatePicker
                  className="inputable"
                  selected={data.raw_finish_value ? new Date( data.raw_finish_value ) : undefined}
                  defaultValue={data.raw_finish_value ? new Date( data.raw_finish_value ) : new Date()}
                  onChange={(e) => handleDateChange(e, 'finish_value')}
                  minDate={new Date()}
                  showTimeSelect
                  placeholderText="Defina a data de hora da finalização"
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Hora"
                  dateFormat="dd/MM/yyyy - HH:mm"
                  popperPlacement="top"
                />
              </div>
            </div>
        }
      </div>
    </Card>
  )
}